import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import { white, lightestGray, backgroundGray, darkBlue } from '@css/constants'

export const GroupName = styled('span')(css`
  ${FontNormal(600)};
  ${fontSize(16)};
  text-transform: uppercase;
`)

export const ExpandedContainer = styled('div')(css`
  background: ${backgroundGray};
  padding: 0 24px 24px;
`)

export const getHeadingStyles = (isOpen: boolean) => css`
  background: ${isOpen ? darkBlue : white};
  color: ${isOpen ? white : darkBlue};
  padding: 13px 20px;
  border: 1px solid ${lightestGray};
  border-right-color: ${isOpen ? 'transparent' : lightestGray};
  border-left-color: ${isOpen ? 'transparent' : lightestGray};

  & svg {
    color: ${isOpen ? white : darkBlue};
  }
`
